import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import * as S from './hero.styles'

import Button from 'src/components/button/button'

interface HeroProps {}

const Hero: React.FC<HeroProps> = () => {
  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "desktopHomeHeroBg.png" }) {
        childImageSharp {
          fluid(maxWidth: 1366, maxHeight: 768, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobile: file(relativePath: { eq: "mobileHomeHeroBg.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <S.Hero>
      <S.MobileBackground fluid={data.mobile.childImageSharp.fluid} style={{ position: 'absolute' }} />
      <S.DesktopBackground fluid={data.desktop.childImageSharp.fluid} style={{ position: 'absolute' }} />
      <S.Mask />
      <S.Wrapper>
        <S.Header>Samochody to nasza pasja.</S.Header>
        <S.ButtonContainer>
          <Button path='/oferta' varaint='arrow' color='white' direction='down'>
            Sprawdź ofertę
          </Button>
        </S.ButtonContainer>
      </S.Wrapper>
    </S.Hero>
  )
}

export default Hero
